import { render, staticRenderFns } from "./InvitationForm.vue?vue&type=template&id=abe96fd4&scoped=true&"
import script from "./InvitationForm.vue?vue&type=script&lang=js&"
export * from "./InvitationForm.vue?vue&type=script&lang=js&"
import style0 from "./InvitationForm.vue?vue&type=style&index=0&id=abe96fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe96fd4",
  null
  
)

export default component.exports